window.Theme = window.Theme || {};

/* -------------------------------------------------------------------------- */
/*                              Utility Functions                             */
/* -------------------------------------------------------------------------- */

/* ---------------------------- Section Updating ---------------------------- */

function updateSections(sections, contextURL, queryParams = null, inSecret = false) {
    contextURL = String(contextURL || '');
    console.log('contextURL', contextURL)
    
    if (contextURL.startsWith('/')) {
        contextURL = contextURL.slice(1);
    }

    return new Promise((resolve, reject) => {
        const basePath = window.Shopify?.routes?.root || '/';
        console.log(`${basePath}${contextURL}`);
        const url = new URL(`${basePath}${contextURL}`, window.location.origin);
        console.log(url);
        console.log(url.toString());
        url.searchParams.set('sections', sections.join(','));

        if (queryParams) {
            Object.entries(queryParams).forEach(([key, value]) => {
                url.searchParams.set(key, value);
            });
        }

        if (!inSecret) {
            sections.forEach((id) => {
                const el = document.getElementById(id);
                if (el) el.classList.add('section-loading');
            });
        }

        fetch(url.toString())
            .then((res) => res.json())
            .then((json) => {
                replaceSections(json);
                resolve(); // done
            })
            .catch((err) => {
                console.error(err);
                reject(err); // pass the error along
            });
    });
}

function replaceSections(entries) {
    for (const [wrapper, html] of Object.entries(entries)) {

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const section = doc.querySelector('#shopify-section-' + wrapper);
        const innerHTML = section ? section.innerHTML : 'NO INNER';

        document.getElementById(wrapper).innerHTML = innerHTML;
        document.getElementById(wrapper)?.classList.remove('section-loading');


    }
}

/* ----------------------------- Form Utilities ----------------------------- */

function serialiseForm(formElement) {
    const formData = new FormData(formElement);

    // Convert FormData to a plain object
    const data = {};
    formData.forEach((value, key) => {
        // Handle multiple properties with the same name
        if (data[key]) {
            if (!Array.isArray(data[key])) data[key] = [data[key]];
            data[key].push(value);
        } else {
            data[key] = value;
        }
    });

    return data;
}

function formToObject(formElement) {
    const formData = new FormData(formElement);
    const data = {};

    const assignValue = (obj, key, value) => {
        if (key in obj) {
            if (!Array.isArray(obj[key])) obj[key] = [obj[key]];
            obj[key].push(value);
        } else {
            obj[key] = value;
        }
    };

    const setNestedValue = (key, value) => {
        // Parse "foo[bar][baz]" into root "foo" + segments ["bar", "baz"]
        // "foo[]" -> segment "" means array push
        const match = key.match(/^([^\[\]]+)((?:\[[^\[\]]*\])*)$/);
        if (!match) {
            assignValue(data, key, value);
            return;
        }

        const rootKey = match[1];
        const rest = match[2];
        const segments = [...rest.matchAll(/\[([^\[\]]*)\]/g)].map(m => m[1]);

        if (segments.length === 0) {
            assignValue(data, rootKey, value);
            return;
        }

        let target = data;
        let currentKey = rootKey;

        for (let i = 0; i < segments.length; i++) {
            const nextSegment = segments[i];
            const isLast = i === segments.length - 1;
            const nextIsArrayPush = nextSegment === '';

            if (isLast) {
                if (nextIsArrayPush) {
                    if (!Array.isArray(target[currentKey])) target[currentKey] = [];
                    target[currentKey].push(value);
                } else {
                    if (!(currentKey in target)) target[currentKey] = {};
                    assignValue(target[currentKey], nextSegment, value);
                }
            } else {
                if (!(currentKey in target) || typeof target[currentKey] !== 'object' || Array.isArray(target[currentKey])) {
                    target[currentKey] = {};
                }
                target = target[currentKey];
                currentKey = nextSegment;
            }
        }
    };

    formData.forEach((value, key) => setNestedValue(key, value));

    return data;
}

/* ---------------------------- Shared Utilities ---------------------------- */

function popupMessage(messageText, type = 'info', duration = 5000) {
    let messages = document.getElementById('messages');

    // Create container
    if (!messages) {
        messages = document.createElement('div');
        messages.id = 'messages';
        document.body.append(messages);
    }

    // Create message
    const message = document.createElement('div');
    const messageContent = document.createElement('div');

    messageContent.innerHTML = messageText;
    message.append(messageContent);

    message.classList.add('message-' + type);
    messages.append(message);
    requestAnimationFrame(() => {
        message.style.maxHeight = message.scrollHeight + 'px';
        message.classList.add('open');
    });

    // Messages will dissappear unless 0
    if (duration) {
        setTimeout(() => { closeMessage(message); }, duration)
    } else {
        const closeBtn = document.createElement('button');
        closeBtn.innerHTML = '&times;';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.classList.add('close');
        messageContent.append(closeBtn);
        closeBtn.addEventListener('click', () => { closeMessage(message); });
    }
    function closeMessage(message) {
        message.style.maxHeight = 0;
        message.classList.add('closing');
        setTimeout(() => {
            message.remove();
            if (messages.children.length == 0) {
                messages.remove;
            }
        }, 500)

    }

}

/* -------------------------------------------------------------------------- */
/*                              Cart & Mini Cart                              */
/* -------------------------------------------------------------------------- */

/* --------------------- Cart Update on Quantity Change --------------------- */
const queueCartUpdate = debounce((submitter) => {
    document.getElementById('cart').requestSubmit(submitter);
}, 500);

if (document.body.classList.contains('page-cart')) {
    document.body.addEventListener('click', function (e) {
        if (e.target.matches('.input-quantity button')) {
            queueCartUpdate(e.target);
        }
    })
}

function debounce(fn, delay) {
    let timeoutId;
    const debounced = (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn(...args), delay);
    };
    debounced.cancel = () => clearTimeout(timeoutId);
    return debounced;
}

/* -------------------------------- Mini Cart ------------------------------- */

class MiniCart {
    constructor(container) {
        this.container = container;

        this.container.dataset.loaded = false;

        const headerCartLink = document.querySelector('.header__icons a[data-role="cart-link"]')
        headerCartLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.open();
        })
        this.#init();

        // Watch for changes


    }



    open(update = true) {
        this.container.classList.add('open');
        if (update) {
            this.load();
        } else {
            this.#init();
            // Ensure we init the layout to account for contents reloaded behind our back
        }
        // Delay to avoid catching the click that triggered open
        setTimeout(() => {
            document.addEventListener('click', this.#handleOutsideClick);
            document.addEventListener('keydown', this.#handleKeydown);
            document.addEventListener('keydown', this.#trapFocus);

            // Optionally focus first element inside cart
            const firstFocusable = this.container.querySelector(
                'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
            );
            firstFocusable?.focus();
        }, 0);
    }

    close() {
        this.container.classList.remove('open');
        document.removeEventListener('click', this.#handleOutsideClick);
        document.removeEventListener('keydown', this.#handleKeydown);
        document.removeEventListener('keydown', this.#trapFocus);
    }

    load() {
        updateSections(['mini-cart'], window.location, undefined, true).then(() => this.#init());
    }

    #handleOutsideClick = (event) => {
        if (!this.container.contains(event.target)) {
            this.close();
        }
    };

    #handleKeydown = (event) => {
        if (event.key === 'Escape') {
            this.close();
        }
    };

    #trapFocus = (event) => {
        const focusableElements = this.container.querySelectorAll(
            'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
        );
        const first = focusableElements[0];
        const last = focusableElements[focusableElements.length - 1];

        if (event.key !== 'Tab') return;

        if (event.shiftKey) {
            // Shift + Tab
            if (document.activeElement === first) {
                event.preventDefault();
                last.focus();
            }
        } else {
            // Tab
            if (document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
    };

    #handleCloseClick(e) {
        e.preventDefault();
        this.close();
    }

    #boundHandleCloseClick = this.#handleCloseClick.bind(this)

    #init() {
        this.container.querySelectorAll('[data-role="close-button"]').forEach((elem) => {
            elem.addEventListener('click', this.#boundHandleCloseClick)
        });
    }
}
const miniCart = new MiniCart(document.getElementById('mini-cart'));


/* --------------------------- Search Menu Opener --------------------------- */
document.querySelector('[data-role="search-button"]').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.header__search').classList.toggle('open');
})

document.querySelectorAll('label[for="mobile-menu"]').forEach((label) => {
    label.addEventListener('click', () => {
        document.querySelectorAll('.mobile-menu input[type="checkbox"]').forEach((checkbox) => {
            checkbox.checked = false;
        });
    });
});

/* -------------------------------------------------------------------------- */
/*                                  All Pages                                 */
/* -------------------------------------------------------------------------- */

/* ------------------------------ Lazy loading ------------------------------ */
document.addEventListener('DOMContentLoaded', () => {
    console.log('The HTML DOM is fully loaded and parsed');
    // Lazy load sections
    updateSections(['cart-bubble'], window.location.href, null, true);
});


/* -------------------------------------------------------------------------- */
/*                               Quantity Boxes                               */
/* -------------------------------------------------------------------------- */

class QtyBox {
    #rawInput;
    #unitTag;
    #btnStepDown;
    #btnStepUp;

    static register(wrapper) {
        if (!wrapper) return null;
        if (wrapper.__instance) {
            // We are already initialised, return instance
            return wrapper.__instance;
        }
        // Otherwise, safely build a brand new instance
        return new QtyBox(wrapper);
    }

    constructor(wrapper) {
        this.wrapper = wrapper;
        this.input = this.wrapper.querySelector('input[type="number"]');
        this.#rawInput = this.wrapper.querySelector('input[data-raw="true"]') ?? this.input;

        this.#unitTag = this.wrapper.querySelector('.unit-tag') ?? null;
        if (this.#unitTag) {
            this.unitSingular = this.#unitTag.dataset.singular;
            this.unitPlural = this.#unitTag.dataset.plural;
        }

        if (wrapper.dataset.invalidMin && wrapper.dataset.invalidMax) {
            this.setCustomInvalidRange(
                parseFloat(wrapper.dataset.invalidMin),
                parseFloat(wrapper.dataset.invalidMax)
            );
            delete wrapper.dataset.invalidMin;
            delete wrapper.dataset.invalidMax;
        }

        this.decimal = this.#rawInput.dataset.decimal ?? false;


        this.#btnStepDown = this.wrapper.querySelector('.input-quantity__down');
        this.#btnStepUp = this.wrapper.querySelector('.input-quantity__up');


        this.wrapper.__instance = this;
        this.#rawInput.__instance = this;

        this.#init();
    }

    #init() {
        // Custom invalid range
        this.input.addEventListener('input', () => {
            console.log('input')
            this.#checkCustomValidation()
            this.#updateUnitTag()
        });
        this.input.addEventListener('change', () => {
            console.log('change')
            this.#checkCustomValidation()
            this.#updateUnitTag()

        });

        if (this.input !== this.#rawInput) {
            this.input.addEventListener('input', () => { this.#syncValues() });
            this.input.addEventListener('change', () => { this.#syncValues() });
        }

        // Step Buttons
        this.#btnStepDown.addEventListener('click', (e) => {
            e.preventDefault();
            this.stepDown();
        });

        this.#btnStepUp.addEventListener('click', (e) => {
            e.preventDefault();
            this.stepUp();
        });

        this.input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
            }
        });

        // Unit Tags



        this.wrapper.dataset.initialized = true;
        console.log(this.input);
    }

    #syncValues() {
        if (this.input !== this.#rawInput) {
            if (this.decimal) {
                this.#rawInput.value = Math.round(parseFloat(this.input.value) * 10);
            } else {
                this.#rawInput.value = this.input.value;
            }
            this.#rawInput.dispatchEvent(new Event('input', { bubbles: true }));
            this.#rawInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    #updateUnitTag() {
        console.log(this);
        if (this.#unitTag) {
            console.log(this.#unitTag);
            let qty = Number(this.input.value);

            if (isNaN(qty)) return;

            if (qty == 1) {
                this.#unitTag.innerText = this.unitSingular;
            } else {
                this.#unitTag.innerText = this.unitPlural;
            }
        }
    }

    setCustomInvalidRange(min, max) {
        this.invalidRange = { min: min, max: max };
        console.log(`Invalid range set between ${min} and ${max}`);
        this.#checkCustomValidation();
    }

    clearCustomInvalidRange() {
        this.invalidRange = null;
        this.input.setCustomValidity('');
        console.log(`Invalid range cleared`);
    }

    #checkCustomValidation() {
        console.log(this.input);
        const value = parseFloat(this.input.value);

        if (this.invalidRange) {
            console.log('Checking custom validation');

            if (value > this.invalidRange.min && value < this.invalidRange.max) {
                const unit = this.unitPlural ? ` ${this.unitPlural}` : '';
                this.input.setCustomValidity(`The special order minimum for this product is ${this.invalidRange.max}${unit}.`);
            } else {
                this.input.setCustomValidity('');
            }
        } else {
            console.log('No custom validation');
        }
    }

    setValue(value, raw = false) {
        if (this.decimal) {
            // We are dealing with a decimalised value
            if (raw) {
                this.input.value = (value * 0.1).toFixed(1);
            } else {
                this.input.value = value;
            }
        } else {
            this.input.value = value;
        }
        this.#syncValues();
        this.#checkCustomValidation();
        this.#updateUnitTag();
    }

    stepDown() {
        this.#step();
    }

    stepUp() {
        this.#step(1);
    }

    #step(up = false) {
        if (up) {
            this.input.stepUp();
        } else {
            this.input.stepDown();
        }

        this.#syncValues();
        this.#checkCustomValidation();
        this.#updateUnitTag();

    }
}

